import api from '../utils/API';

const getAllDocumentContrats = () => {
    return api.get('/DocumentContrat/list');
};

const addDocumentContrat = (data) => {
    return api.post('/DocumentContrat/add', data);
};

const deleteDocumentContrat = (data) => {
    return api.delete('/DocumentContrat/delete', { data });
};

const updateObligation = (id, obligation) => {
    return api.put(`/DocumentContrat/${id}/obligation`, { obligation });
};


const getDocumentContratGroupedByContrat = () => {
    return api.get('/DocumentContrat/grouped');
};

export {
    getAllDocumentContrats,
    addDocumentContrat,
    deleteDocumentContrat,
    updateObligation,
    getDocumentContratGroupedByContrat
};
